var AdaptiveImage = require( "../../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "87e5b6811f7ec9c6b4991b334b565992.png",
    width: 24,
    height: 24
});